import { produce } from 'immer';
import dayjs from 'dayjs';
import { AUTH_LOGOUT } from '../actions';
import {
  BBB_ENABLED_GET,
  BBB_URL_GET,
  CHECK_EVENT_TUTOR,
  EVENT_DATES_LIST_GET,
  EVENT_DETAILS_GET,
  EVENT_DETAILS_RESET,
  GET_USERS_BY_SESSION,
  JOIN_BBB_SESSION,
  RESET_BBB_SESISON,
  SESSIONS_LIST_GET,
  SESSIONS_LIST_RESET,
} from '../actions/events';

const initialState = {
  dates: [],
  events: [],
  sessions: [],
  details: {},
  sessionUsers: [],
  pager: {},
  userIsTutor: {},
  bbb: {
    enabled: false,
    link: null,
  },
};

const learningEventsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case EVENT_DETAILS_RESET:
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case EVENT_DATES_LIST_GET._SUCCESS: {
        const { response = [] } = action;
        const sessions = {};
        response.forEach((s) => {
          if (s?.activity_date) {
            const date = dayjs(s.activity_date * 1000).format('YYYYMMDD');
            sessions[date]?.length > 0
              ? sessions[date].push(s)
              : (sessions[date] = [s]);
          }
        });
        draft.dates = Object.keys(sessions).map((s) =>
          dayjs(s, 'YYYYMMDD').unix()
        );
        break;
      }
      case SESSIONS_LIST_GET._SUCCESS: {
        const { response = [], keepAllSessions } = action;
        const sessions = {};
        if (keepAllSessions) {
          // keep all sessions for each event
          response.forEach((s) => {
            const id = s?.event_id;
            if (id) {
              sessions[id]?.length > 0
                ? sessions[id].push(s)
                : (sessions[id] = [s]);
            }
          });
          // sort sessions by date
          const allSessions = [];
          Object.values(sessions).forEach((s) => allSessions.push(...s));
          draft.sessions = allSessions.sort(
            (a, b) => a.activity_date - b.activity_date
          );
        } else {
          // keep first session for each event (filter by event_id)
          response.forEach((s) => {
            const id = s?.event_id;
            if (id && !sessions[id]) sessions[id] = s;
          });
          // sort sessions by date
          draft.sessions = Object.values(sessions).sort(
            (a, b) => a.activity_date - b.activity_date
          );
        }
        break;
      }
      case SESSIONS_LIST_RESET: {
        draft.sessions = initialState.sessions;
        break;
      }

      case CHECK_EVENT_TUTOR._SUCCESS: {
        const { response = {} } = action;
        draft.userIsTutor = response;
        break;
      }

      case EVENT_DETAILS_GET._SUCCESS: {
        const { response = {} } = action;
        draft.details = { ...response };
        break;
      }

      case GET_USERS_BY_SESSION._SUCCESS: {
        const { response } = action;
        draft.sessionUsers = response;
        break;
      }

      case JOIN_BBB_SESSION._SUCCESS:
      case BBB_URL_GET._SUCCESS: {
        draft.bbb.link = action?.response?.link;
        break;
      }

      case BBB_ENABLED_GET._SUCCESS: {
        draft.bbb.enabled = action?.response?.enabled;
        break;
      }

      case RESET_BBB_SESISON: {
        draft.bbb = initialState.bbb;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default learningEventsReducer;
